import tree from "../../../components/tree.vue"
import iColumn from "../../../components/Column.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import { domainName } from "../../../utility/index"

export default {
  name: "userManagement",
  components: { tree, iColumn, iTable, IPagination },
  data() {
    return {
      formInline: {
        orgId: '',
      },
      orgIdList: [],
      list: [],
      tableHeight: '',
      loading: false,
    };
  },
  created() {
    this.getOrg()
  },
  mounted() {
    this.getData()

    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    getOrg() {
      this.$store.dispatch('tree/GET_SELECTUSERORG').then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.orgIdList = res.data.data
          }
        }
      })
    },
    setClass({ row, column, rowIndex, columnIndex }) {
      if (columnIndex <= 1) {
        return 'addBorder'
      }
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      // console.log(row, column, rowIndex, columnIndex)
      // if (rowIndex === this.list.length - 1) {
      //   if (columnIndex === 0) {
      //     return [1, 2];
      //   } else {
      //     return [0, 0];
      //   }
      // }
    },
    indexMethod(index) {
      if (index == this.list.length - 1) {
        return
      } else {
        return index + 1
      }
    },
    handleResize() {
      const windowHeight = window.innerHeight;
      this.tableHeight = (windowHeight - 300) + 'px';
    },
    getData() {
      this.loading = true
      let param = {
        userId: sessionStorage.getItem("userId"),
        orgId: this.formInline.orgId,
      }
      this.$store.dispatch('ReportAnalysis/GET_SELECTCAROVERVIEW', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.list = res.data.data
            this.loading = false
          }
        }
      })
    },
    downCar() {
      if (domainName) {
        if (domainName.split(':')[0] !== 'localhost') {
          let url = `https://${domainName}/v1/getExportExcel/exportCarOverview?orgId=${this.formInline.orgId}&userId=${sessionStorage.getItem("userId")}`
          location.href = url
        } else {
          let host = 'localhost:8080'
          let url = `https://${host}/v1/getExportExcel/exportCarOverview?orgId=${this.formInline.orgId}&userId=${sessionStorage.getItem("userId")}`
          location.href = url
        }
      }
    },
    onSearch() {
      this.currentPage = 1
      this.getData()
    },
    onClear() {
      this.formInline = {
        loginName: '',
        userName: '',
      }
      this.getData()
    },
    changeSize(item) {
      this.pageSize = item.pageSize
      this.currentPage = item.pageNum
      this.getData();
    },
  },
};
